import React from 'react';
import { Edit, SimpleForm, TextInput,useRecordContext,TextField, NumberInput } from 'react-admin';
import { Scrollbars } from "react-custom-scrollbars";
import Swal from "sweetalert2";
// import { Link } from "react-router-dom";
import { getNotificationPermission } from '../Notification';
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption,getLocalStorageKey } from "../common/common";
const apiUrl = RUN_TIME_API_ENDPOINT;

const EditRedirect = (_basePath, _id, data) => `/sales_officers/edit/2`;


const ListingModal = (props) => {
    const id = getLocalStorageKey("id");
    const notifyPermission = localStorage.getItem("notificationPermission");
    const [permissionStatus, setPermissionStatus] = React.useState((notifyPermission == null || notifyPermission =="false") ? false:true);

    console.log('permissionStatus',permissionStatus);
    const [open, setOpen] = React.useState(false);
    const record = useRecordContext();
    console.log("record ListingModal",record)
    
    const onSave = (record) => {
      const url = `${apiUrl}/admin_panel_users/${id}/enable_push_notification`;
      const data = {
        enable_push_notification:!permissionStatus
      };
      const options = CommonHeaderOption();
      options.method = "PATCH";
      options.body = JSON.stringify(data);
      console.log(data);
    //   Swal.fire({
    //     text: "Please wait while your request is being processed.",
    //     allowOutsideClick: false,
    //     didOpen: () => {
    //       Swal.showLoading();
    //     },
    //   });
      return fetch(url, options)
        .then((res) => {
          if (res.status === 401) {
            localStorage.removeItem("__state");
            window.location.href = "#/login";
          }
          return res.json();
        })
        .then((json) => {
          console.log("json ===>", json);
          setPermissionStatus(!permissionStatus);
          localStorage.setItem("notificationPermission", JSON.stringify(!permissionStatus));
          if (!permissionStatus) {
            getNotificationPermission(id).then(() =>{
                console.log('getNotificationPermission then');
              })
            }
        //   window.location.reload();
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Unable to process your request at this time. Please try again later.",
          });
          console.log(error);
        });
    };
  
    const openListingModal = () => {
      setOpen(true);
    };
  
    const onCloseModal = () => {
      setOpen(false);
    };
  
    const onToggle = (e) => {
      console.log("record onToggle",record ,e.target.value)
      let settingValue = notifyPermission !== true ? "ON" : "OFF";

      Swal.fire({
        text:
          "Are you sure to change the value of notification permission " +
          !permissionStatus +
          ".",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {  
            onSave(record);
        // window.location.reload();
        }
      }).catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Unable to process your request at this time. Please try again later.",
        });
        console.log(error);
      });
    };
  
      console.log("props Listing called", props,notifyPermission);
      let recordValue = permissionStatus && permissionStatus !=null ? true : false;
      console.log("provvvvvvvvvvvps", recordValue);
      return (
        <div className="set-noti-row">
          <div>Notification Permission</div>
          <div
            className={`toggle-button-container ${
              recordValue ? "toggle-button-on" : ""
            }`}
          >
            <label className="switch">
              <input
                type="checkbox"
                checked={recordValue}
                onChange={onToggle}
              />{" "}
              <div></div>
            </label>
            <span className="switch-status">{recordValue}</span>
          </div>
          {/* {open && onToggle()} */}
        </div>
      );
  }

  const FormToolBar = () => (
    <div>
    </div>
)

const AdminPanelUsers = ({ permissions, ...props }) => {
      
    return (
        <Edit title="Profile"  {...props} >
            <SimpleForm toolbar={<FormToolBar />} className="half-grid" >
                <TextInput title='name' source="name" disabled />
                <TextInput title='email' source="email" disabled />
                <TextInput title='role description' source="role_description" disabled />
                <NumberInput title='phone number' source='phone' disabled />
                <ListingModal/>
            </SimpleForm>
        </Edit>
    )
}

export default AdminPanelUsers;